module.exports = __webpack_public_path__ + "img/logo.793ca3ed.png";